// extracted by mini-css-extract-plugin
module.exports = {"ForgotPassword":"ForgotPassword_ForgotPassword__OtQsu","buttons":"ForgotPassword_buttons__n9fI5"};